import { PropsWithChildren } from 'react';
import './responsive-content.less';

interface Props {
  className?: string
}

export default function ResponsiveContent(props: PropsWithChildren<Props>) {
  let className = "responsive-content";
  if (props.className) {
    className += " " + props.className;
  }

  return <div className={className}>
    {props.children}
  </div>
}